<script setup lang="ts">
// "Update available" pill (Paolo 2026-11-03 19:0x): shown when useBuildVersion finds a newer bundle while the user is
// on the page; a tap reloads. Fixed to the top edge, under the phone's system bar, so it reads on a phone first.
defineProps<{ visible: boolean }>()
const emit = defineEmits<{ (e: 'reload'): void }>()
</script>

<template>
  <button v-if="visible" type="button" class="update-pill" data-testid="update-available" @click="emit('reload')">
    New version available · tap to reload
  </button>
</template>

<style scoped>
.update-pill { position: fixed; top: calc(env(safe-area-inset-top, 0px) + 8px); left: 50%; transform: translateX(-50%); z-index: 2000;
  background: #1f3a5a; color: #e0e0e0; border: 1px solid #6ea8df; border-radius: 14px; padding: 6px 14px; font-size: 12px; font-weight: 600;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.5); cursor: pointer; max-width: calc(100vw - 32px); }
.update-pill:hover { background: #26486e; }
</style>
